// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordOptions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ActionBar component
 */
!(function () {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.UserAccountConstants');

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Input = require('share/components/controls/Izenda.Input');
  var Button = require('share/components/controls/Izenda.Button');
  var EventsUtils = require('EventUtils');
  var action = require('./Izenda.PasswordOptionsAction');

  var UserLookUp = require('modules/User/Izenda.UserLookUp');

  var PasswordOptions = action(function (props) {
    var store = props.store;
    var userAccountList = store.model.userAccountList.peek();
    var recipientValue = store.configUserCloned.recipientValue.toJS();
    var configUserCloned = store.configUserCloned;
    var validations = configUserCloned.sendEmail ? constants.USER_SETUP_CONSTRAINTS.RECIPIENTS : null;
    var localization = props.localization;

    var iconCopyTooltip = document.queryCommandSupported("copy")
      ? localization.getText('USER_SETUP_LABEL_COPY_PASSWORD_LINK')
      : localization.getText('USER_SETUP_LABEL_COPY_PASTE');

    return (
      <Popup visible type="none" onClosing={props.onClosing} autoClose={false}>
        <Popup.Header title={localization.getText('USER_SETUP_LABEL_PASSWORD_OPTIONS')} className='u_floatLeft'/>
        <Popup.Body>
          <GridLayout className='izenda-PasswordOptions'>
            <GridLayout.Row>
              <Button label={localization.getText('USER_SETUP_LABEL_GENERATE_PASSWORD_LINK')} className='u_floatLeft' onClick={props.onGeneratePasswordLink} />
            </GridLayout.Row>
            <GridLayout.Row>
              <div className='izenda-PasswordLinkCustom u_inlineBlock'>
                <Input className='form-control u_inlineBlock'
                       id='izenda-PasswordLinkCustom'
                       value={configUserCloned.passwordLink} disabled/>
                <i className='icon-copy u-posAbsolute izenda-IconCopyClipBoard'
                   title={iconCopyTooltip}
                   onClick={props.onCopyPasswordLink} />
              </div>
            </GridLayout.Row>
            <GridLayout.Row>
              <label>
                <input type='checkbox'
                       className='u_floatLeft'
                       checked={configUserCloned.sendEmail}
                       onChange={EventsUtils.notifyChange(props.updateSendEmailState, EventsUtils.CHECKBOX)}/>
                <span className='u_floatLeft u_marginLeft'>
                  {constants.PASSWORD_OPSTIONS.SEND_PASSWORD}
                </span>
              </label>
            </GridLayout.Row>
            <GridLayout.Row>
              <span className='validation required u_floatLeft u_marginLeft'>
                {constants.PASSWORD_OPSTIONS.EMAIL}
              </span>
            </GridLayout.Row>
            <fieldset disabled={!configUserCloned.sendEmail}>
              <GridLayout.Row>
                <UserLookUp open={false}
                            disabled={!configUserCloned.sendEmail}
                            onToggle={function () {return false;}}
                            data={userAccountList}
                            valueField='emailAddress'
                            textField='emailAddress'
                            value={recipientValue}
                            onChange={props.addRecipients}
                            validations={validations}
                            field='Recipients'
                            onChangeFromPopup={props.getRecipients}
                            usingPopup/>
              </GridLayout.Row>
            </fieldset>
          </GridLayout>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type='accept'>{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type='cancel'>{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  });

  module.exports = PasswordOptions;
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/ActionBar/Izenda.PasswordOptions.jsx